module.exports = __webpack_public_path__ + "static/media/rtl-submit.32c1cf78.png";